import { create } from "zustand/react"
import { AllRegions, RegionDetails } from "../../../types"


interface JobsPageState {
    selectedKey: string | null
    setSelectedKey: (key: string) => void
    selectedCompanyName: string | null
    setSelectedCompanyName: (companyName: string) => void
    selectedRegion?: string
    setSelectedRegion: (region?: string) => void
    selectedRegionDetails: RegionDetails | null

}

const useJobsPageStore = create<JobsPageState>()((set) => ({
    selectedKey: null,
    selectedCompanyName: null,
    selectedRegion: "",
    selectedRegionDetails: null,
    setSelectedKey: (key) => { set(state => ({ ...state, selectedKey: key, })) },
    setSelectedCompanyName: (companyName) => { set(state => ({ ...state, selectedCompanyName: companyName, })) },
    setSelectedRegion: (region) => {

        const regionDetails = AllRegions.find((r) => { return r.regionKey == region })

        set(state => ({
            ...state,
            selectedRegion: region,
            selectedRegionDetails: regionDetails,
        }))

    }
}))

export default useJobsPageStore